
import {  Button, Tooltip, Popover} from 'antd';
import React from "react";
import "./NavbarButton.css";
import useWindowDimensions from "../../hooks/useWindowDimensions"

const NavbarButton = ({icon, onClick, title, tooltipPlacement, content, ...props}) => {
    const size = useWindowDimensions();
    return (
        <>
        {size.width<576&&
        <Tooltip>
            {content && (
                <Popover placement={tooltipPlacement || size.width < 576 && "top" || "right"} content={content} title={title} trigger="click">
                    <Button size="large" className="navbar-button" shape="circle" onClick={onClick} {...props}><i className={icon}></i></Button>
                </Popover>
            )}
            {!content && (
                <Button size="large" className="navbar-button" shape="circle" onClick={onClick} {...props}><i className={icon}></i></Button>
            )}
        </Tooltip>
        ||  <>

        <Tooltip placement={tooltipPlacement || size.width < 576 && "top" || "top"} title={title} trigger="hover">
            {content && (
                <Popover placement={tooltipPlacement || size.width < 576 && "top" || "right"} content={content} title={title} trigger="click">
                    <Button size="large" className="navbar-button" shape="circle" onClick={onClick} {...props}><i className={icon}></i></Button>
                </Popover>
            )}
            
        </Tooltip>

        <Tooltip placement={tooltipPlacement || size.width < 576 && "top" || "top"} title={title} trigger="hover">
           
            {!content && (
                <Button size="large" className="navbar-button" shape="circle" onClick={onClick} {...props}><i className={icon}></i></Button>
            )}
        </Tooltip>
        
        </>
        }

        
        </>
    )
}


export default NavbarButton;